// Simple mock data for the enterprise configuration demo
export const enterpriseExamples = {
  sapS4HanaMigration: {
    getConfiguration: () => ({
      projectId: 'sap-s4hana-001',
      projectName: 'SAP S/4HANA Migration - Manufacturing Division',
      projectType: {
        id: 'sap-s4hana-migration',
        name: 'SAP S/4HANA Migration',
        category: 'erp',
        description: 'Enterprise SAP S/4HANA transformation project',
        industry: 'manufacturing',
        complexity: 'enterprise'
      },
      enabledPhases: ['project-preparation', 'business-blueprint', 'realization', 'final-preparation', 'go-live-support'],
      menuOverrides: {
        'project-preparation': {
          categories: [
            {
              id: 'project-setup',
              name: 'Project Setup & Organization',
              description: 'Establish project structure and governance',
              icon: 'Users',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'project-charter', name: 'Project Charter & Scope' },
                { id: 'team-structure', name: 'Team Structure & RACI' }
              ]
            }
          ]
        },
        'business-blueprint': {
          categories: [
            {
              id: 'business-process-design',
              name: 'Business Process Design',
              description: 'Map and design business processes in SAP',
              icon: 'GitBranch',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'process-mapping', name: 'As-Is Process Mapping' },
                { id: 'gap-analysis', name: 'Gap Analysis & Fit-Gap' }
              ]
            }
          ]
        },
        'realization': {
          categories: [
            {
              id: 'system-configuration',
              name: 'System Configuration',
              description: 'Configure SAP system modules',
              icon: 'Settings',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'module-config', name: 'Module Configuration' },
                { id: 'custom-development', name: 'Custom Development' }
              ]
            }
          ]
        }
      },
      terminology: {
        'system': 'SAP S/4HANA',
        'database': 'SAP HANA',
        'platform': 'Azure',
        'stakeholders': 'Business Process Owners',
        'environment': 'Enterprise Manufacturing'
      },
      branding: {
        primaryColor: '#0070f3',
        secondaryColor: '#0051cc'
      }
    }),
    getWorkflowConfiguration: () => ({
      type: 'sap-style',
      profiles: {
        project: 'SAP_PROJECT_001',
        milestone: 'SAP_MILESTONE_001',
        status: 'SAP_STATUS_001'
      },
      approvalGates: ['blueprint-approval', 'realization-approval', 'golive-approval']
    }),
    getSecurityConfiguration: () => ({
      rbac: true,
      auditLog: true,
      dataEncryption: true
    }),
    exportConfiguration: () => JSON.stringify({
      projectType: 'sap-s4hana-migration',
      configuration: 'SAP S/4HANA Enterprise Configuration'
    }, null, 2)
  },

  oracleCloudERP: {
    getConfiguration: () => ({
      projectId: 'oracle-erp-001',
      projectName: 'Oracle Fusion Cloud ERP Implementation',
      projectType: {
        id: 'oracle-cloud-erp',
        name: 'Oracle Cloud ERP Implementation',
        category: 'erp',
        description: 'Oracle Fusion Cloud ERP implementation project',
        industry: 'enterprise',
        complexity: 'enterprise'
      },
      enabledPhases: ['initiate', 'plan', 'execute', 'control', 'close'],
      menuOverrides: {
        'initiate': {
          categories: [
            {
              id: 'project-initiation',
              name: 'Project Initiation',
              description: 'Establish project foundation and governance',
              icon: 'FileText',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'business-case', name: 'Business Case & ROI' },
                { id: 'stakeholder-identification', name: 'Stakeholder Identification' }
              ]
            }
          ]
        },
        'plan': {
          categories: [
            {
              id: 'detailed-planning',
              name: 'Detailed Planning',
              description: 'Create comprehensive project plans',
              icon: 'Calendar',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'project-schedule', name: 'Project Schedule' },
                { id: 'resource-allocation', name: 'Resource Allocation' }
              ]
            }
          ]
        },
        'execute': {
          categories: [
            {
              id: 'implementation',
              name: 'Implementation',
              description: 'Execute Oracle Fusion implementation',
              icon: 'Code',
              priority: 'critical',
              status: 'not-started',
              subcategories: [
                { id: 'fusion-setup', name: 'Fusion Cloud Setup' },
                { id: 'data-migration', name: 'Data Migration' }
              ]
            }
          ]
        }
      },
      terminology: {
        'system': 'Oracle Fusion ERP',
        'database': 'Oracle Autonomous Database',
        'platform': 'Oracle Cloud Infrastructure',
        'stakeholders': 'Functional Super Users',
        'environment': 'Oracle Cloud'
      },
      branding: {
        primaryColor: '#c74634',
        secondaryColor: '#a73829'
      }
    }),
    getWorkflowConfiguration: () => ({
      type: 'oracle-style',
      templates: {
        task: 'ORACLE_TASK_TEMPLATE',
        resource: 'ORACLE_RESOURCE_TEMPLATE',
        deliverable: 'ORACLE_DELIVERABLE_TEMPLATE'
      },
      projectClass: 'TECHNOLOGY',
      billingMethod: 'COST_PLUS'
    }),
    getSecurityConfiguration: () => ({
      rbac: true,
      auditLog: true,
      dataEncryption: true
    }),
    exportConfiguration: () => JSON.stringify({
      projectType: 'oracle-cloud-erp',
      configuration: 'Oracle Fusion Cloud ERP Configuration'
    }, null, 2)
  }
};

export class EnterpriseProjectConfigurationManager {
  private config: any;
  
  constructor(projectType: string) {
    // Mock implementation for demo
    this.config = enterpriseExamples.sapS4HanaMigration.getConfiguration();
  }
  
  getConfiguration() {
    return this.config;
  }
  
  getWorkflowConfiguration() {
    return enterpriseExamples.sapS4HanaMigration.getWorkflowConfiguration();
  }
  
  getSecurityConfiguration() {
    return enterpriseExamples.sapS4HanaMigration.getSecurityConfiguration();
  }
  
  exportConfiguration() {
    return enterpriseExamples.sapS4HanaMigration.exportConfiguration();
  }
}
